// 工作台
import customerServiceWorkbench from 'commonComponent/workBench/customerServiceWorkbench'; // 客服工作台
import commodityWorkbench from 'commonComponent/workBench/commodityWorkbench'; // 商品工作台
import operatingWorkbench from 'commonComponent/workBench/operatingWorkbench'; // 运营工作台
import distributionWorkBench from 'commonComponent/workBench/distributionWorkBench'; // 分销工作台
import logisticWorkbench from 'commonComponent/workBench/logisticWorkbench'; // 物流工作台
import bossWorkBench from 'commonComponent/workBench/bossWorkBench'; // boss工作台


// 配置平台
import cpChrusers from 'commonComponent/peiZhi/cp_c_hrusers';

// 权限
import quanXian from 'commonComponent/peiZhi/quanXian/quanXian'; // 公共权限页面
import CP_C_INORG from 'commonComponent/peiZhi/cp_c_inorg'; // 内部组织
// import lookUserJurisdiction from 'commonComponent/peiZhi/quanXian/lookUserJurisdiction'; // 查看用户权限


const customizedPage = require(`./${process.env.BRANCH_ENV}/customized.page`).default;

export default {
  ...customizedPage,
  // 工作台
  commodityWorkbench: {
    component: commodityWorkbench
  },
  operatingWorkbench: {
    component: operatingWorkbench
  },
  distributionWorkBench: {
    component: distributionWorkBench
  },
  bossWorkBench: {
    component: bossWorkBench
  },
  customerServiceWorkbench: {
    component: customerServiceWorkbench
  },
  logisticWorkbench: {
    component: logisticWorkbench
  },
  // 配置平台
  cp_c_hrusers: {
    component: cpChrusers
  },
  CP_C_INORG: {
    component: CP_C_INORG
  },

  PERMISSIONS: { // 权限
    component: quanXian
  },
  // userPermission: {
  //   component: lookUserJurisdiction // 查看用户权限
  // }

};